function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292c2e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.677 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M40.316,100.975,34.672,85.75h-4.9v2.8h2.947l.969,2.615H24.2l-1.9,5.509H9.233v2.8h6.438l5.517,8.311H19.013v2.8h10.23L36.57,98.927l1.121,3.024Z",
  transform: "translate(-9.233 -85.75)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.894 5.629)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 2.801,
  height: 4.062,
  transform: "matrix(0.931, -0.365, 0.365, 0.931, 0, 1.023)"
})))), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7.014,14.027A7.014,7.014,0,0,1,2.054,2.054a7.014,7.014,0,1,1,4.96,11.973Zm0-9.6A2.584,2.584,0,1,0,9.6,7.013,2.587,2.587,0,0,0,7.014,4.429Z",
  transform: "translate(0 17.039)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7.014,14.027A7.014,7.014,0,0,1,2.054,2.054a7.014,7.014,0,1,1,4.96,11.973Zm0-9.6A2.584,2.584,0,1,0,9.6,7.013,2.587,2.587,0,0,0,7.014,4.429Z",
  transform: "translate(28.793 17.039)"
}));

function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.819,
    height: 31.066,
    viewBox: "0 0 42.819 31.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.488931b8.svg";
export { ForwardRef as ReactComponent };